module.exports = __webpack_public_path__ + "public/Icons/defalutImage.svg?7b54ee46";